"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "HooksController", {
    enumerable: true,
    get: function() {
        return HooksController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _ncError = require("~/helpers/ncError");
const _globalguard = require("~/guards/global/global.guard");
const _PagedResponse = require("~/helpers/PagedResponse");
const _hooksservice = require("~/services/hooks.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let HooksController = class HooksController {
    async hookList(context, tableId) {
        return new _PagedResponse.PagedResponseImpl(await this.hooksService.hookList(context, {
            tableId
        }));
    }
    async hookCreate(context, tableId, body, req) {
        const hook = await this.hooksService.hookCreate(context, {
            hook: body,
            tableId,
            req
        });
        return hook;
    }
    async hookDelete(context, hookId, req) {
        return await this.hooksService.hookDelete(context, {
            hookId,
            req
        });
    }
    async hookUpdate(context, hookId, body, req) {
        return await this.hooksService.hookUpdate(context, {
            hookId,
            hook: body,
            req
        });
    }
    async hookTest(context, body, req) {
        try {
            await this.hooksService.hookTest(context, {
                hookTest: _extends({}, body, {
                    payload: _extends({}, body.payload, {
                        user: req == null ? void 0 : req.user
                    })
                }),
                tableId: req.params.tableId,
                req
            });
            return {
                msg: 'The hook has been tested successfully'
            };
        } catch (e) {
            console.error(e);
            _ncError.NcError.get(context).webhookError(e.message);
        }
    }
    async tableSampleData(context, tableId, event, operation, version, includeUser) {
        return await this.hooksService.tableSampleData(context, {
            tableId,
            event,
            operation,
            version,
            includeUser: includeUser === 'true'
        });
    }
    async hookLogList(context, hookId, req) {
        return new _PagedResponse.PagedResponseImpl(await this.hooksService.hookLogList(context, {
            query: req.query,
            hookId
        }), _extends({}, req.query, {
            count: await this.hooksService.hookLogCount(context, {
                hookId
            })
        }));
    }
    async hookTrigger(context, hookId, rowId, req) {
        return await this.hooksService.hookTrigger(context, {
            hookId,
            req,
            rowId
        });
    }
    constructor(hooksService){
        this.hooksService = hooksService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/tables/:tableId/hooks',
        '/api/v2/meta/tables/:tableId/hooks'
    ]),
    (0, _extractidsmiddleware.Acl)('hookList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('tableId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], HooksController.prototype, "hookList", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/tables/:tableId/hooks',
        '/api/v2/meta/tables/:tableId/hooks'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('hookCreate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('tableId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.HookReqType === "undefined" ? Object : _nocodbsdk.HookReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], HooksController.prototype, "hookCreate", null);
_ts_decorate([
    (0, _common.Delete)([
        '/api/v1/db/meta/hooks/:hookId',
        '/api/v2/meta/hooks/:hookId'
    ]),
    (0, _extractidsmiddleware.Acl)('hookDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('hookId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], HooksController.prototype, "hookDelete", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/db/meta/hooks/:hookId',
        '/api/v2/meta/hooks/:hookId'
    ]),
    (0, _extractidsmiddleware.Acl)('hookUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('hookId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.HookReqType === "undefined" ? Object : _nocodbsdk.HookReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], HooksController.prototype, "hookUpdate", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/tables/:tableId/hooks/test',
        '/api/v2/meta/tables/:tableId/hooks/test'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('hookTest'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Body)()),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _nocodbsdk.HookTestReqType === "undefined" ? Object : _nocodbsdk.HookTestReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], HooksController.prototype, "hookTest", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/tables/:tableId/hooks/samplePayload/:event/:operation/:version',
        '/api/v2/meta/tables/:tableId/hooks/samplePayload/:event/:operation/:version'
    ]),
    (0, _extractidsmiddleware.Acl)('tableSampleData'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('tableId')),
    _ts_param(2, (0, _common.Param)('event')),
    _ts_param(3, (0, _common.Param)('operation')),
    _ts_param(4, (0, _common.Param)('version')),
    _ts_param(5, (0, _common.Query)('includeUser')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        Object,
        Object,
        Object,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], HooksController.prototype, "tableSampleData", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/hooks/:hookId/logs',
        '/api/v2/meta/hooks/:hookId/logs'
    ]),
    (0, _extractidsmiddleware.Acl)('hookLogList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('hookId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], HooksController.prototype, "hookLogList", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v2/meta/hooks/:hookId/trigger/:rowId'
    ]),
    (0, _extractidsmiddleware.Acl)('hookTrigger'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('hookId')),
    _ts_param(2, (0, _common.Param)('rowId')),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], HooksController.prototype, "hookTrigger", null);
HooksController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _hooksservice.HooksService === "undefined" ? Object : _hooksservice.HooksService
    ])
], HooksController);
